import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-edit-subs-limit',
  templateUrl: './edit-subs-limit.component.html',
  styleUrls: ['./edit-subs-limit.component.css']
})
export class EditSubsLimitComponent extends BaseComponent implements OnInit {
  customer_id;
  editLimitForm: FormGroup;
  getCompanyobj: any = [];
  status: boolean = true;
  submitted = false;
  selectedCompany:any ='';
  subsObj:any = [];
  limit_id:any;
  limitObj:any = [];
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService:MasterService,
  ) { 
    super();
  }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();

    let self = this;

    //get item details using id
    if (localStorage.getItem("edit_subscription_limit_id")) {
      this.limit_id = localStorage.getItem("edit_subscription_limit_id");
      this.selectedCompany = localStorage.getItem("subscription_limit_edit_company_id");

      this.masterService.getSubscriptionLimitById(this.selectedCompany,this.limit_id).subscribe(response => {
       
        if (response.status) {
          this.status = false;
          self.limitObj = response.data;
          self.dataBinding();
        }
      });
    }

    this.editLimitForm = this.formBuilder.group({
      selectedCompany: [''],
      sub_id: ['', [Validators.required]],                                  
      component_name: ['', [Validators.required, Validators.maxLength(100)]],
      component_limit: ['',[]],
      time_limit: ['', []],
      orderno: ['',[]]   
    });

    this.subscriptionList();





  }

  dataBinding() {
    this.editLimitForm = this.formBuilder.group({
      selectedCompany: [this.selectedCompany],
      sub_id: [this.limitObj.sub_id, [Validators.required]],                                  
      component_name: [this.limitObj.component_name, [Validators.required, Validators.maxLength(100)]],
      component_limit: [this.limitObj.component_limit,[]],
      time_limit: [this.limitObj.time_limit, []],
      orderno: [this.limitObj.orderno,[]] 
    });
  }

  getCompany() {
    let self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self, (id) => { self.subscriptionList(); });

    }, error => {
      console.log(error);
    });
  }

  subscriptionList(){
    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();
      this.masterService.getSubscriptionListDropdown(this.selectedCompany,1000,0).subscribe(data => {
        this.ngxSpinnerService.hide();
        if (data.status) {
          if (data.data.rows == null) { this.subsObj = [] }
          else { this.subsObj = data.data.rows }
        } else {
          this.subsObj = [];
        }
      }, error => { console.log(error);this.ngxSpinnerService.hide(); });
    } else {
      this.subsObj = [];
      this.selectedCompany = "";
      this.ngxSpinnerService.hide();
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  get f() { return this.editLimitForm.controls; }


  editNewCategoryData(){
    this.submitted = true;
    if (this.editLimitForm.invalid) {
      return;
    }
    let { sub_id, component_name, component_limit, time_limit, orderno  } = this.editLimitForm.value;
    let obj = {
      sub_id: sub_id,                                  
      component_name: component_name,
      component_limit: component_limit,
      time_limit:time_limit,
      orderno: orderno 
    }
    this.masterService.updateSubscriptionLimit(this.selectedCompany,this.limit_id,obj).subscribe(data=>{
      if (data.status) {
        this.toastrService.success("Subscription limit updated successfully");
        this.router.navigateByUrl(`/corporate/subscriptionLimit`);
      } else {
        this.toastrService.error(data.message);
      }
    },error => {
      this.toastrService.error(error.message);
    });
  }
}
